"use client";

import SizeBar from "@/components/terms/sidebar";
import Link from 'next/link';
import ScrollSpy from "@/components/shared/scroll-spy";
import ScrollButton from '@/components/shared/scroll-top-button';

import Header from "@/components/layout/header";
import Footer from "@/components/layout/footer";


const navigation = [
  { name: '1. Quality', href: '#quality' },
  { name: '2. FAQ', href: '#faq' },
]

const onPress = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  e.preventDefault();
  const target = window.document.getElementById(
    e.currentTarget.href.split("#")[1]
  );
  if (target) {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export default function PageBody() {
  return (
    <>
      <Header />
      <main>
      <div className="min-h-full">
        <div className="py-32">
          <div className="mx-auto max-w-4xl sm:px-2 grid lg:max-w-7xl grid-cols-12 gap-8 px-2 lg:px-8">
            <div className="sm:col-span-2 block sm:border-r col-span-12">
              <SizeBar />
            </div>
            <div className="sm:col-span-8 col-span-12">
              {/* <h1 className="text-2xl font-bold tracking-tight text-gray-900">Customer Terms of Service</h1> */}
              
                <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
                  <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"> Quality </h1>
                  <p className="mt-1 text-sm leading-7 text-gray-600">
                    Last modified December 15, 2019
                  </p>
                  <ScrollSpy activeClass="text-blue-600" useBoxMethod={false}>
                    <section id="quality" className='pt-12'>
                      <h2 className="mt-8 text-xl font-bold tracking-tight text-gray-900"> 1. Quality </h2>
                      <p className="mt-4">
                        Each year, millions of items are produced with MF with a remarkable 98.1% defect-free rate.
                      </p>
                      <p className="mt-4">
                        Every new production run is a series of handoffs between designers, pattern makers, sampling rooms, production staffs, print makers, and fabric mills — all dedicated to providing the best cost to quality product for you.
                      </p>
                      <p className="mt-4">
                        We achieve these high standards by establishing and continuously working with vetted and the best matched vendors for your job.
                      </p>
                    </section>

                    <section id="faq" className='pt-12'>
                      <h2 className="mt-8 text-xl font-bold tracking-tight text-gray-900"> 2. FAQs  </h2>

                      <p className='mt-4 font-semibold'> What Accepted Quality Limit (AQL) does MF use? </p>
                      <p className="mt-2">
                        G-1, 4.0/6.5/10 for major/minor/slight defects for orders $50,000~$99,999
                        <br/> 
                        G-1, 2.5/4.0/6.5 for major/minor/slight defects for orders {'>'} $100,000
                      </p>

                      <p className='mt-4 font-semibold'> Is AQL applied on all orders? </p>
                      <p className="mt-2">
                        AQL is only applied to bulk orders that are $50,000 and above.
                      </p> 

                      <p className='mt-4 font-semibold'> May I select a different AQL? </p>
                      <p className="mt-2">
                        Different AQLs are subjected to our approval. AQLs are largely dependent on the price per unit of the item you&apos;re paying for. You may get MF to engage a third-party to perform an AQL.
                      </p>

                      <p className='mt-4 font-semibold'> How do I report a quality issue with my order? </p>
                      <p className="mt-2">
                        Drop us an email with your order id via our contact us form. Do take pictures of the errors.
                      </p>

                      <p className='mt-4 font-semibold'> Are there warranties on your products? </p>
                      <p className="mt-2">
                        Manufacturing defects have to be reported to MF within seven working days. If there is indeed a major error, MF will provide remedy to the issue at hand.
                      </p>

                      <p className='mt-4 font-semibold'> What are MF wash instructions? </p>
                      <p className="mt-2">
                        MF recommends a 30 degree celsius and warm iron on natural fibres and no ironing for synthetic fibres. If you have wash requirements for your products, please inform us before you start your project. If not, MF will not be liable to any damages arising from your wash or care methods.
                      </p>
                    </section>
                  </ScrollSpy>
                </div>

            </div>
            <div className="hidden sm:col-span-2 sm:block mb-5">
              <nav aria-label="Sidebar" className="sticky top-20 divide-y divide-gray-300 overflow-auto h-screen pb-20">
                <ul role="list" className="flex flex-1 flex-col gap-y-7">
                  <li>
                    <ul role="list" className="space-y-1">
                      <li className='block rounded-md py-2 pr-2 pl-2 text-sm leading-6 font-semibold text-gray-700'> ON THIS PAGE </li>
                      {navigation.map((item) => (
                        <li key={item.name}>
                          <Link
                            onClick={(e) => onPress(e)}
                            href={item.href}
                            className='block rounded-md py-2 pr-2 pl-2 text-sm leading-5 font-semibold text-gray-700'
                          >
                            <div data-to-scrollspy-id={item.href.slice(1)}>
                              {item.name}
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <ScrollButton />
    </main>
      <Footer />
    </>
  )
}